import { useMutation } from 'react-query';
import axios from 'axios';

import { RegistrationData } from '@/models/RegistrationData';
import type { RegistrationResponse } from '@/models/RegistrationResponse';
import { AwsConfigApiGateway } from '@/utils/config/api';

export function useRegisterUser() {
  return useMutation<RegistrationResponse, unknown, RegistrationData>((data: RegistrationData) =>
    axios
      .post<RegistrationResponse>(`${AwsConfigApiGateway.adminApiUrl}/registration`, data)
      .then((r) => r.data), {
    onSuccess: () => {
      // Add any actions you want to perform on successful mutation
    },
    onError: () => {
      // Add any actions you want to perform if mutation fails
    },
  });
}
